module.exports = __webpack_public_path__ + "img/bgusers.0e8f49a2.jpg";